<app-header></app-header>
<div class="d-flex flex-column body mb-5">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
